"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1878,3845],{

/***/ 13866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14564);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86886);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59242);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68720);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56721);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(99842);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61659);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74030);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _utils_filtersStorage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85627);
/* harmony import */ var _utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7360);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73739);
/* harmony import */ var _hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89698);
/* harmony import */ var _contexts_SegmentationFiltersContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99207);
















var LocationFilter = function() {
    var ref = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), isEmbraceTheme = ref.isEmbraceTheme, isCareTheme = ref.isCareTheme;
    var ref1 = (0,_contexts_SegmentationFiltersContext__WEBPACK_IMPORTED_MODULE_5__/* .useSegmentationFiltersContext */ .RZ)(), filters = ref1.filters, setFilters = ref1.setFilters, fetchResults = ref1.fetchResults;
    var userGeoInfo = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__/* .usePageAttributes */ .l)().userGeoInfo;
    var ref2 = (0,_hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), validate = ref2.validate, hasError = ref2.hasError;
    var localStorageFilters = (0,_utils_filtersStorage__WEBPACK_IMPORTED_MODULE_7__/* .loadFilters */ .dm)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), anchorEl = ref3[0], setAnchorEl = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), zipCodeInput = ref4[0], setZipCodeInput = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), cityInput = ref5[0], setCityInput = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), stateInput = ref6[0], setStateInput = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchGeoInfo = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                var initialZipCode, data, ref, ref1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            initialZipCode = (0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_10__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo);
                            setZipCodeInput(initialZipCode);
                            return [
                                4,
                                validate(initialZipCode)
                            ];
                        case 1:
                            data = _state.sent();
                            setCityInput((ref = data === null || data === void 0 ? void 0 : data.city) !== null && ref !== void 0 ? ref : "");
                            setStateInput((ref1 = data === null || data === void 0 ? void 0 : data.state) !== null && ref1 !== void 0 ? ref1 : "");
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchGeoInfo() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchGeoInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(event) {
            var value, data, ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.value;
                        if (value.length > 5) return [
                            2
                        ];
                        setZipCodeInput(value);
                        if (!(value.length <= 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validate(value)
                        ];
                    case 1:
                        data = _state.sent();
                        setCityInput((ref = data === null || data === void 0 ? void 0 : data.city) !== null && ref !== void 0 ? ref : "");
                        setStateInput((ref1 = data === null || data === void 0 ? void 0 : data.state) !== null && ref1 !== void 0 ? ref1 : "");
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.clickOnSegmentationFilter */ .Sj.clickOnSegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleApplyClick = function() {
        var ref;
        var resetPage = zipCodeInput === "" || zipCodeInput !== (filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode);
        var updatedFilters = {
            zipcode: zipCodeInput
        };
        setFilters({
            location: {
                zipcode: zipCodeInput,
                city: cityInput,
                state: stateInput
            }
        });
        if (localStorageFilters) {
            updatedFilters = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, localStorageFilters), {
                zipcode: zipCodeInput
            });
        }
        fetchResults(updatedFilters, resetPage);
        setAnchorEl(null);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.applySegmentationFilter */ .Sj.applySegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            handleApplyClick();
        }
    };
    var getHelperText = function() {
        if (hasError) return "Enter a valid ZIP code (e.g. “02453”)";
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "";
    };
    var getDisplayText = function() {
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "City, State";
    };
    var open = Boolean(anchorEl);
    var showDisplay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Boolean(zipCodeInput && cityInput && stateInput);
    }, [
        zipCodeInput,
        cityInput,
        stateInput
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        mb: {
            xs: 3,
            sm: 6
        },
        mr: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                "aria-describedby": "location-filter",
                color: isEmbraceTheme ? "primary" : "secondary",
                variant: "outlined",
                onClick: handleClick,
                size: isEmbraceTheme ? "small" : "medium",
                sx: function(theme) {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, isCareTheme && {
                        minWidth: "252px",
                        height: "48px",
                        borderRadius: 4,
                        borderColor: theme.palette.care.grey[300]
                    }, isEmbraceTheme && {
                        minWidth: "252px"
                    });
                },
                startIcon: isEmbraceTheme ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}),
                endIcon: isEmbraceTheme ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    variant: "body3",
                    sx: function(theme) {
                        return {
                            flex: 1,
                            textAlign: "left",
                            fontSize: "1.125rem",
                            fontWeight: showDisplay ? 700 : 400,
                            color: showDisplay ? undefined : theme.palette.care.grey[500]
                        };
                    },
                    children: getDisplayText()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                id: "location-filter",
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                sx: function(theme) {
                    return {
                        "& .MuiPaper-root": {
                            minWidth: "100px",
                            borderRadius: "24px",
                            border: "1px solid ".concat(theme.palette.care.grey[300]),
                            marginTop: theme.spacing(1),
                            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15);",
                            padding: theme.spacing(3, 2),
                            maxWidth: "375px",
                            width: "252px"
                        },
                        "& .MuiLink-root": {
                            textAlign: "right"
                        }
                    };
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                id: "locationFilter-zipCode",
                                name: "locationFilter-zipCode",
                                label: "ZIP code",
                                type: "number",
                                value: zipCodeInput,
                                error: hasError,
                                helperText: getHelperText(),
                                onKeyUp: handleKeyUp,
                                onChange: onChange,
                                sx: {
                                    paddingBottom: "16px",
                                    // removes number arrows from Chrome, Safari, Edge, Opera
                                    "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                                        appearance: "none",
                                        margin: 0
                                    },
                                    // removes number arrows from Firefox
                                    "& input[type=number]": {
                                        appearance: "textfield"
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                color: "primary",
                                variant: "contained",
                                onClick: handleApplyClick,
                                disabled: (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) > 0 && (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) < 5 || hasError,
                                children: "Apply"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationFilter);


/***/ }),

/***/ 34435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArticleCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);









var ArticleCard = function(param) {
    var imageUrl = param.imageUrl, title = param.title, url = param.url, description = param.description, articleCreateDate = param.articleCreateDate, _slotProps = param.slotProps, slotProps = _slotProps === void 0 ? {} : _slotProps;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    // remove the <p> tag from the description
    var previewDescription = description ? "".concat(description.replace(/<\/?p>/gi, ""), "...") : null;
    var articleDate = articleCreateDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        dateTime: articleCreateDate,
        useOrdinalDay: false,
        useLongMonth: true,
        useFullDate: true
    }) : null;
    var amplitudeEventCardClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Clicked Article Carousel"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.link), {
            onClick: amplitudeEventCardClick,
            href: url,
            target: !isSmallViewport ? "_blank" : "_self",
            variant: "link2",
            sx: function(theme) {
                return {
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                        cursor: "pointer",
                        textDecoration: "none"
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.image), {
                    mb: {
                        xs: 1,
                        sm: 2
                    },
                    borderRadius: "24px",
                    component: "img",
                    src: imageUrl,
                    alt: title,
                    loading: "lazy"
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.title), {
                            component: "h3",
                            variant: "h3",
                            mb: 1,
                            children: he__WEBPACK_IMPORTED_MODULE_1___default().decode(title)
                        })),
                        previewDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.description), {
                            component: "p",
                            variant: isLargeViewport ? "body2" : "body3",
                            color: "text.secondary",
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_10___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(articleDate ? "".concat(articleDate, " - ").concat(previewDescription) : previewDescription))
                            }
                        }))
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 83845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleSection": function() { return /* binding */ ArticleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35129);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);
/* harmony import */ var _components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34435);






var ArticleSection = function(param) {
    var articles = param.articles;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)().isSmallViewport;
    var segmentNameSingular = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNameSingular;
    if (articles.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        maxWidth: "lg",
        sx: {
            pt: {
                xs: 4,
                sm: 0
            },
            mb: {
                xs: 6,
                md: 12
            },
            mt: {
                sm: 6,
                md: 12
            },
            position: "relative",
            px: {
                xl: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                component: "h2",
                variant: isSmallViewport ? "h1" : "display3",
                mb: {
                    xs: 4,
                    sm: 6
                },
                mt: 0,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .l, {
                controlVariant: isSmallViewport ? "none" : "topRight",
                showProgressIndicator: isSmallViewport,
                itemsPerView: isSmallViewport ? 1 : 3,
                children: articles.map(function(article) {
                    var ref;
                    if (!((ref = article.largeImage) === null || ref === void 0 ? void 0 : ref.imageUrl)) return null;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__/* .ArticleCard */ .T, {
                        url: article.url,
                        imageUrl: article.largeImage.imageUrl,
                        title: article.title,
                        description: article.description,
                        articleCreateDate: article.createDate
                    }, article.title);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticleSection);


/***/ }),

/***/ 35129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46237);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87688);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19957);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98820);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96373);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54743);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);










var Carousel = function(param) {
    var children = param.children, _controlVariant = param.controlVariant, controlVariant = _controlVariant === void 0 ? "none" : _controlVariant, _showProgressIndicator = param.showProgressIndicator, showProgressIndicator = _showProgressIndicator === void 0 ? false : _showProgressIndicator, _itemGap = param.itemGap, itemGap = _itemGap === void 0 ? 3 : _itemGap, _itemsPerView = param.itemsPerView, itemsPerView = _itemsPerView === void 0 ? 3 : _itemsPerView, slotProps = param.slotProps;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var originalSlides = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    var totalSteps = originalSlides.length;
    var slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides));
    var gapInPixels = parseInt(theme.spacing(itemGap), 10);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(totalSteps), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTransitioning = ref1[0], setIsTransitioning = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), slideOffset = ref2[0], setSlideOffset = ref2[1];
    var touchStartX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var touchEndX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!containerRef.current) return undefined;
        var resizeObserver = new ResizeObserver(function(entries) {
            var ref;
            var containerWidth = entries[0].contentRect.width;
            var itemWidth = (containerWidth - (itemsPerView - 1) * gapInPixels) / itemsPerView;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.style.setProperty("--item-width", "".concat(itemWidth, "px"));
            setSlideOffset(itemWidth + gapInPixels);
        });
        resizeObserver.observe(containerRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        itemsPerView,
        gapInPixels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isTransitioning) return undefined;
        var timer = setTimeout(function() {
            setIsTransitioning(false);
            // When we reach the third set, jump back to equivalent position in second set
            if (currentSlide >= totalSteps * 2) {
                setCurrentSlide(currentSlide - totalSteps);
            }
            // When we reach the first set, jump to equivalent position in second set
            if (currentSlide < totalSteps) {
                setCurrentSlide(currentSlide + totalSteps);
            }
        }, 300);
        return function() {
            clearTimeout(timer);
        };
    }, [
        currentSlide,
        isTransitioning,
        totalSteps
    ]);
    var amplitudeEventButtonClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Rotate Article Carousel"
        });
    };
    var goToNextSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr + 1;
            return newSlide;
        });
    };
    var goToPrevSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr - 1;
            return newSlide;
        });
    };
    var handleTouchStart = function(e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function(e) {
        var ref;
        var ref1;
        var endX = (ref1 = (ref = e.changedTouches[0]) === null || ref === void 0 ? void 0 : ref.clientX) !== null && ref1 !== void 0 ? ref1 : 0;
        if (Math.abs(touchStartX.current - endX) > 50) {
            if (touchStartX.current - endX > 0) {
                goToNextSlide();
            } else {
                goToPrevSlide();
            }
        }
        touchStartX.current = 0;
        touchEndX.current = 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        alignItems: "center",
        children: [
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mr: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToPrevSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: containerRef,
                sx: {
                    "--item-width": "auto",
                    position: "relative",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        onTouchStart: handleTouchStart,
                        onTouchEnd: handleTouchEnd,
                        sx: {
                            display: "flex",
                            overflow: "hidden",
                            width: "100%"
                        }
                    }, slotProps), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                transform: "translateX(-".concat(currentSlide * slideOffset, "px)"),
                                transition: isTransitioning ? "transform 0.3s ease-in-out" : "none"
                            },
                            children: slides.map(function(slide, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    "aria-hidden": index < currentSlide || index > currentSlide + itemsPerView - 1,
                                    sx: {
                                        width: "var(--item-width)",
                                        flexShrink: 0,
                                        mr: index === slides.length - 1 ? 0 : itemGap,
                                        "& img": {
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "cover",
                                            display: "block",
                                            maxWidth: "100%",
                                            aspectRatio: "3/2"
                                        },
                                        p: 1
                                    },
                                    children: slide
                                }, "carousel-slide-".concat(index + 1));
                            })
                        })
                    })),
                    controlVariant === "topRight" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end",
                            position: "absolute",
                            top: "-85px",
                            right: "0",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    mr: 2
                                },
                                onClick: goToPrevSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                onClick: goToNextSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            })
                        ]
                    }),
                    showProgressIndicator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            mt: {
                                xs: 2,
                                md: 6
                            },
                            "& ul .dot": {
                                height: "5px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            stepNumber: currentSlide % totalSteps + 1,
                            totalSteps: totalSteps
                        })
                    })
                ]
            }),
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ml: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToNextSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 99207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ SegmentationFiltersContext; },
/* harmony export */   "RZ": function() { return /* binding */ useSegmentationFiltersContext; }
/* harmony export */ });
/* unused harmony export filtersCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var filtersCtx = {
    filters: {
        __typename: "SEOSegmentationFilters",
        location: {
            __typename: "SEOLocationFilters",
            zipcode: "",
            city: "",
            state: null
        }
    },
    setFilters: function(_filters, _reset) {},
    fetchResults: function(_filterVals, _resetPage) {}
};
var SegmentationFiltersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(filtersCtx);
var useSegmentationFiltersContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SegmentationFiltersContext);
};


/***/ }),

/***/ 85665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallChildCare.js
var IllustrationSmallChildCare = __webpack_require__(4867);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumChildCare.js
var IllustrationMediumChildCare = __webpack_require__(93365);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallSeniorCare.js
var IllustrationSmallSeniorCare = __webpack_require__(73807);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumSeniorCare.js
var IllustrationMediumSeniorCare = __webpack_require__(8998);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallAdultCare.js
var IllustrationSmallAdultCare = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumAdultCare.js
var IllustrationMediumAdultCare = __webpack_require__(20043);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallPetCare.js
var IllustrationSmallPetCare = __webpack_require__(57240);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumPetCare.js
var IllustrationMediumPetCare = __webpack_require__(55610);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallHousekeeping.js
var IllustrationSmallHousekeeping = __webpack_require__(16416);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumHousekeeping.js
var IllustrationMediumHousekeeping = __webpack_require__(6662);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallTutoring.js
var IllustrationSmallTutoring = __webpack_require__(97620);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumTutoring.js
var IllustrationMediumTutoring = __webpack_require__(38358);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallDayCare.js
var IllustrationSmallDayCare = __webpack_require__(12090);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumDayCare.js
var IllustrationMediumDayCare = __webpack_require__(48308);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/getSideIllustration.tsx




/**
 * Returns the side illustration based on the provided SEO segment ID and service ID.
 * @param {Object} params - The parameters object.
 * @param {string} params.seoSegmentId - The SEO segment ID.
 * @param {string} params.serviceId - The service ID.
 * @returns {Record<string, JSX.Element> | null} - A record of JSX elements representing the side illustrations, or null if no matching illustrations are found.
 */ var getSideIllustration = function(param) {
    var seoSegmentId = param.seoSegmentId, serviceId = param.serviceId;
    var segmentId = "/".concat(seoSegmentId.split("/")[1]);
    var childCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallChildCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumChildCare/* default */.Z, {})
    });
    var seniorCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallSeniorCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumSeniorCare/* default */.Z, {})
    });
    var adultCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallAdultCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumAdultCare/* default */.Z, {})
    });
    var petCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallPetCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumPetCare/* default */.Z, {})
    });
    var housekeepingIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallHousekeeping/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumHousekeeping/* default */.Z, {})
    });
    var tutoringIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallTutoring/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumTutoring/* default */.Z, {})
    });
    var dayCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallDayCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumDayCare/* default */.Z, {})
    });
    var _obj;
    var sideIllustrationMapForVerticals = Object.freeze((_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.CHILDCARE */.Xs.CHILDCARE, childCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE, seniorCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.PETCAREXX */.Xs.PETCAREXX, petCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.HOUSEKEEP */.Xs.HOUSEKEEP, housekeepingIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.TUTORINGX */.Xs.TUTORINGX, tutoringIllustrations), _obj));
    var sideIllustrationMapForSegmentIDs = Object.freeze({
        "/adult-care": adultCareIllustrations,
        "/day-care": dayCareIllustrations
    });
    var _segmentId, ref;
    return (ref = (_segmentId = sideIllustrationMapForSegmentIDs[segmentId]) !== null && _segmentId !== void 0 ? _segmentId : sideIllustrationMapForVerticals[serviceId]) !== null && ref !== void 0 ? ref : null;
};

// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/Illustration.tsx





var Illustration = function(param) {
    var sx = param.sx;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), seoSegmentId = ref.seoSegmentId, serviceId = ref.serviceId;
    var isMediumOrLargeViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.between("md", "xl");
    });
    var isLargestViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("xl");
    });
    var sideIllustration = getSideIllustration({
        seoSegmentId: seoSegmentId,
        serviceId: serviceId
    });
    if (!sideIllustration) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_to_consumable_array/* default */.Z)(Array.isArray(sx) ? sx : [
            sx
        ]),
        children: [
            isMediumOrLargeViewport && sideIllustration.small,
            isLargestViewport && sideIllustration.medium
        ]
    });
};


/***/ }),

/***/ 49366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32826);
/* harmony import */ var _helpers_narrowSegmentationStats__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21444);




var ProductSchema = function() {
    var seoSegmentationStats = (0,_context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useSearchDirectoryData */ .Q)().seoSegmentationStats;
    var segmentNamePluralLowerCase = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNamePluralLowerCase;
    var segmentationStats = (0,_helpers_narrowSegmentationStats__WEBPACK_IMPORTED_MODULE_3__/* .narrowSegmentationStats */ .f)(seoSegmentationStats);
    var ref;
    var totalReviewCount = (ref = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.totalReviewCount) !== null && ref !== void 0 ? ref : 0;
    var ref1;
    var avgReviewRating = (ref1 = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.avgReviewRating) !== null && ref1 !== void 0 ? ref1 : 0;
    var showProductSchema = totalReviewCount >= 5 && avgReviewRating > 0;
    var nameTitle = segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);
    var ProductSchemaList = function() {
        var roundAvgReviewRating = avgReviewRating.toFixed(1);
        var product = {
            "@context": "https://schema.org",
            "@type": "Product",
            name: nameTitle,
            brand: {
                "@type": "Organization",
                name: "Care.com"
            }
        };
        // Only add aggregateRating if rating is 4.5 or higher
        if (roundAvgReviewRating !== null && parseFloat(roundAvgReviewRating) >= 4.5) {
            product.aggregateRating = {
                "@type": "AggregateRating",
                ratingValue: roundAvgReviewRating,
                reviewCount: "".concat(totalReviewCount),
                bestRating: "5",
                worstRating: "1"
            };
        }
        return product;
    };
    if (!showProductSchema) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "productSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(ProductSchemaList())
        }
    });
};


/***/ }),

/***/ 3092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ ReviewsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./src/components/common/Carousel.tsx
var Carousel = __webpack_require__(35129);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(89609);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Rating/Rating.js + 6 modules
var Rating = __webpack_require__(25628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/components/common/ReadMore.tsx
var ReadMore = __webpack_require__(33424);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewCard.tsx





var ReviewCard = function(param) {
    var revieweeName = param.revieweeName, comment = param.comment, rating = param.rating, reviewerName = param.reviewerName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        sx: {
            border: "none",
            minHeight: {
                sm: "375px",
                md: "250px"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            sx: {
                "&.MuiCardContent-root": {
                    p: 3
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    mb: 1,
                    children: revieweeName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                    defaultValue: rating,
                    readOnly: true,
                    sx: {
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* ReadMore */.y, {
                        component: "div",
                        showLessLabel: "read less",
                        showMoreLabel: "read more",
                        charLimit: 140,
                        value: comment,
                        variant: "body2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    textAlign: "right",
                    sx: {
                        color: "text.secondary"
                    },
                    children: "- ".concat(reviewerName)
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/useSearchResultReviews.tsx



var useSearchResultReviews = function(seoSegmentationSearchResults, searchDirectoryTemplateType) {
    var maxNumberOfReviewsToDisplay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var caregiverSearchResults = seoSegmentationSearchResults.caregiverSearchResults, providerSearchResults = seoSegmentationSearchResults.providerSearchResults;
    var filterProfilesWithReviews = function(profiles) {
        return profiles.filter(function(profile) {
            return profile.latestReview && profile.latestReview.comment && profile.latestReview.rating;
        }).map(function(profile) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profile), {
                latestReview: profile.latestReview
            });
        });
    };
    var mapCaregiverReviewCardProps = function(profiles) {
        return profiles.map(function(param) {
            var _latestReview = param.latestReview, reviewer = _latestReview.reviewer, comment = _latestReview.comment, rating = _latestReview.rating, caregiver = param.caregiver;
            return {
                revieweeName: caregiver.member.displayName,
                reviewerName: reviewer.displayName !== "" ? reviewer.displayName : "Care member",
                comment: comment,
                rating: rating
            };
        });
    };
    var mapProviderReviewCardProps = function(profiles) {
        return profiles.map(function(param) {
            var _latestReview = param.latestReview, reviewer = _latestReview.reviewer, comment = _latestReview.comment, rating = _latestReview.rating, seoSegmentationProvider = param.seoSegmentationProvider;
            return {
                revieweeName: seoSegmentationProvider.provider.name,
                reviewerName: reviewer.displayName !== "" ? reviewer.displayName : "Care member",
                comment: comment,
                rating: rating
            };
        });
    };
    if (searchDirectoryTemplateType === "CAREGIVER") {
        var caregiverProfiles = filterProfilesWithReviews(caregiverSearchResults);
        if (caregiverProfiles.length < 3) return null;
        return mapCaregiverReviewCardProps(caregiverProfiles).slice(0, maxNumberOfReviewsToDisplay);
    }
    if (searchDirectoryTemplateType === "SMB") {
        var providerProfiles = filterProfilesWithReviews(providerSearchResults);
        if (providerProfiles.length < 3) return null;
        return mapProviderReviewCardProps(providerProfiles).slice(0, maxNumberOfReviewsToDisplay);
    }
    if (searchDirectoryTemplateType === "HYBRID") {
        var caregiverProfiles1 = filterProfilesWithReviews(caregiverSearchResults);
        var providerProfiles1 = filterProfilesWithReviews(providerSearchResults);
        if (caregiverProfiles1.length + providerProfiles1.length < 3) {
            return null;
        }
        return (0,_to_consumable_array/* default */.Z)(mapCaregiverReviewCardProps(caregiverProfiles1)).concat((0,_to_consumable_array/* default */.Z)(mapProviderReviewCardProps(providerProfiles1))).slice(0, maxNumberOfReviewsToDisplay);
    }
    return null;
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewsSection.tsx













var ReviewsSection = function(param) {
    var searchDirectoryTemplateType = param.searchDirectoryTemplateType, slotProps = param.slotProps;
    var ref, ref1, ref2, ref3;
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var seoSegmentationSearchResults = pageData.seoSegmentationSearchResults;
    var segmentationStats = ((ref = pageData.seoSegmentationStats) === null || ref === void 0 ? void 0 : ref.__typename) === "SEOSegmentationStatsSuccess" ? pageData.seoSegmentationStats.caregiverStats : null;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref4 = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingularLowerCase = ref4.segmentNameSingularLowerCase, segmentNamePluralLowerCase = ref4.segmentNamePluralLowerCase, segmentNamePlural = ref4.segmentNamePlural, city = ref4.city, state = ref4.state, pageType = ref4.pageType;
    var reviewsList = useSearchResultReviews(seoSegmentationSearchResults, searchDirectoryTemplateType);
    var ref5;
    var avgReviewRating = (ref5 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref1 = segmentationStats.avgReviewRating) === null || ref1 === void 0 ? void 0 : ref1.toFixed(1)) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var totalReviews = (ref6 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref2 = segmentationStats.totalReviewCount) === null || ref2 === void 0 ? void 0 : ref2.toLocaleString()) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var totalProviders = (ref7 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref3 = segmentationStats.totalProviders) === null || ref3 === void 0 ? void 0 : ref3.toLocaleString()) !== null && ref7 !== void 0 ? ref7 : "";
    var showSubheadline = avgReviewRating.length > 0 && totalReviews.length > 0 && totalProviders.length > 0;
    var headline = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL) {
            return "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents in ").concat(city, ",&nbsp;").concat(state);
        }
        return "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents");
    }();
    var subheadline = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL) {
            return "".concat(segmentNamePlural, " in ").concat(city, ",&nbsp;").concat(state, " are rated ").concat(avgReviewRating, " out of 5 stars based on ").concat(totalReviews, " reviews of the ").concat(totalProviders, " listed ").concat(segmentNamePluralLowerCase);
        }
        return "".concat(segmentNamePlural, " are rated ").concat(avgReviewRating, " out of 5 stars based on ").concat(totalReviews, " reviews of the ").concat(totalProviders, " listed ").concat(segmentNamePluralLowerCase);
    }();
    if (!reviewsList || reviewsList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            bgcolor: "background.accent.accent1"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            sx: {
                py: {
                    xs: 6,
                    sm: 8
                },
                px: {
                    xl: 0
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.headline), {
                    component: "h2",
                    variant: isSmallViewport ? "h1" : "display3",
                    sx: {
                        mt: 0,
                        mb: {
                            xs: 3,
                            sm: 2
                        }
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(headline))
                    }
                })),
                showSubheadline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.subheadline), {
                    component: "p",
                    variant: "body2",
                    sx: {
                        mb: {
                            xs: 3,
                            sm: 6
                        },
                        maxWidth: {
                            sm: "80%"
                        }
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(subheadline))
                    }
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
                    showProgressIndicator: isSmallViewport,
                    itemsPerView: isSmallViewport ? 1 : 3,
                    controlVariant: isSmallViewport ? "none" : "topRight",
                    children: reviewsList.map(function(param) {
                        var revieweeName = param.revieweeName, reviewerName = param.reviewerName, comment = param.comment, rating = param.rating;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                            revieweeName: revieweeName,
                            reviewerName: reviewerName,
                            comment: comment,
                            rating: rating
                        }, "".concat(revieweeName, "-").concat(reviewerName));
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useZipCodeValidation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./src/API/seoSegmentationValidateZipCode.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query validateZipCode($input: SEOValidateZipCodeInput!) {\n    seoSegmentationValidateZipCode(input: $input) {\n      ... on SEOValidateZipCodeSuccess {\n        __typename\n        city\n        state\n      }\n      ... on SEOValidateZipCodeError {\n        __typename\n        error {\n          message\n          ... on DataNotAvailableError {\n            message\n          }\n          ... on DataNotAvailableForGivenPageNumberError {\n            message\n          }\n          ... on UrlNotFoundError {\n            message\n          }\n          ... on InvalidSEOZipCodeError {\n            message\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VALIDATE_ZIP_CODE = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var seoSegmentationValidateZipCode = (VALIDATE_ZIP_CODE);

;// CONCATENATED MODULE: ./src/components/hooks/useZipCodeValidation.tsx






function useZipCodeValidation() {
    var ref = (0,react.useState)(""), zipCode = ref[0], setZipCode = ref[1];
    var ref1 = (0,react.useState)(""), city = ref1[0], setCity = ref1[1];
    var ref2 = (0,react.useState)(""), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(seoSegmentationValidateZipCode, {
        variables: {
            input: {
                zipcode: zipCode
            }
        }
    }), 1), validateZipCode = ref4[0];
    var validate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newZipCode, ref, ref1, response, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newZipCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                        setHasError(false);
                        setZipCode(newZipCode);
                        if (newZipCode.length < 5) {
                            setCity("");
                            setState("");
                            setHasError(false);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: zipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        if (!(newZipCode.length === 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validateZipCode({
                                variables: {
                                    input: {
                                        zipcode: newZipCode
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        res = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.seoSegmentationValidateZipCode;
                        if ((res === null || res === void 0 ? void 0 : res.__typename) === "SEOValidateZipCodeSuccess") {
                            setCity(res === null || res === void 0 ? void 0 : res.city);
                            setState(res === null || res === void 0 ? void 0 : res.state);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: res === null || res === void 0 ? void 0 : res.city,
                                    state: res === null || res === void 0 ? void 0 : res.state
                                })
                            ];
                        }
                        if (newZipCode.length === 5 && (res === null || res === void 0 ? void 0 : (ref1 = res.error) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "InvalidSEOZipCodeError") {
                            setCity("");
                            setState("");
                            setHasError(true);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            Promise.resolve({
                                zipCode: zipCode,
                                city: city,
                                state: state
                            })
                        ];
                }
            });
        });
        return function validate() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        validate: validate,
        hasError: hasError
    };
}


/***/ }),

/***/ 73006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getArticlesList; }
/* harmony export */ });
/**
 * @JSDOC
 * This function extracts the articles data from the SEOArticlesList object.
 * It checks if the SEOArticlesList is of type 'SEOArticlesListSuccess' and returns the articles.
 * If the type is not 'SEOArticlesListSuccess', it returns an empty array.
 * @param {seoSegmentationListingPage['seoArticlesList']} seoArticlesList - The SEOArticlesList object.
 * @returns {seoSegmentationListingPage['seoArticlesList']['articles']} - The articles data or an empty array.
 * @example
 * const articles = getArticlesList(seoArticlesList);
 * // articles will be of type seoSegmentationListingPage['seoArticlesList']['articles']
 * // If seoArticlesList is of type 'SEOArticlesListSuccess', it will contain the articles.
 * // If not, it will be an empty array.
 */ var getArticlesList = function(seoArticlesList) {
    if (seoArticlesList.__typename === "SEOArticlesListSuccess") {
        var ref;
        var ref1;
        return (ref1 = (ref = seoArticlesList.seoArticlesList) === null || ref === void 0 ? void 0 : ref.articles) !== null && ref1 !== void 0 ? ref1 : [];
    }
    return [];
};


/***/ }),

/***/ 21444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ narrowSegmentationStats; }
/* harmony export */ });
var narrowSegmentationStats = function(seoSegmentationStats) {
    return (seoSegmentationStats === null || seoSegmentationStats === void 0 ? void 0 : seoSegmentationStats.__typename) === "SEOSegmentationStatsSuccess" ? seoSegmentationStats.caregiverStats : null;
};


/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ })

}]);